import React, { useEffect, useState } from "react";
import throttle from "lodash/throttle";

import SuperCarersOperations from "logic/SuperCarersOperations";
import LocalOperations from "logic/LocalOperations";

import { formTriggeredByScroll } from "data/segmentCustomEvents";
import PostCodeSearchResults from "components/postcode_search/PostCodeSearchResults";
import PostCodeSearchMessages from "components/postcode_search/PostCodeSearchMessages";
import PostCodeSearchHelper from "components/postcode_search/PostCodeSearchHelper";
import LoadingPlaceholder from "components/utils/LoadingPlaceholder";
import OnboardingFormContainer from "components/onboarding/OnboardingFormContainer";
import { getBottomOfPage } from "helpers/screenHelper";
import OnboardingCTA from "components/onboarding/components/OnboardingCTA";
import theme from "theme";
import useOptimizeVariant from "custom_hooks/useOptimizeVariant";

const PostcodeSearchPage = () => {
  const isMobile = window.innerWidth < theme.screen.tablet;
  const [postcodeSearchResult, setPostcodeSearchResult] = useState({
    carers: [],
    carersMin: window.POSTCODE_CARER_RESULTS_TOTAL,
    carersTotal: null,
    latitude: null,
    liveinOnly: false,
    loading: !!LocalOperations.parseUrlParams().postcode,
    longitude: null,
    postcode: LocalOperations.parseUrlParams().postcode || "",
    postcodeArea: null,
    postcodeValid: null
  });
  const [taxonomies, setTaxonomies] = useState(null);
  const [mapRendered, setMapRendered] = useState(false);
  const [isFormOpen, toggleFormOpenState] = useState(false);
  // const useVariant = useOptimizeVariant("OQZKjsWpQrqrhKjChYwbnw");
  const useVariant = false;

  const {
    carers,
    carersMin,
    carersTotal,
    latitude,
    liveinOnly,
    loading,
    longitude,
    postcode,
    postcodeArea,
    postcodeValid
  } = postcodeSearchResult;

  const toggleForm = state => {
    toggleFormOpenState(state);
    if (isMobile) {
      document.body.style.overflowY = state ? "hidden" : "scroll";
    }
  };

  const openFormIfAtBottom = () => {
    if (window.scrollY >= getBottomOfPage()) {
      formTriggeredByScroll();
      toggleForm(true);
    }
  };

  const fetchTaxonomies = async () => {
    const returnedTaxonomies = await SuperCarersOperations.fetchTaxonomies();
    setTaxonomies(returnedTaxonomies);
  };

  const runPostcodeSearch = async () => {
    const result = await PostCodeSearchHelper.runSearch(postcodeSearchResult);
    setPostcodeSearchResult({ ...postcodeSearchResult, ...result });
  };

  const renderMap = (lat, lng) => {
    if (window.google) {
      /* eslint-disable no-new */
      new google.maps.Map(document.getElementById("map"), {
        center: { lat, lng },
        zoom: 12,
        clickableIcons: false,
        disableDefaultUI: true,
        disableDoubleClickZoom: true,
        draggable: false,
        gestureHandling: "none"
      });
    }
  };

  useEffect(() => {
    if (postcode) {
      // fetchTaxonomies();
      runPostcodeSearch();
    }
    if (postcodeValid && !mapRendered) {
      // renderMap(latitude, longitude);
      setMapRendered(true);
    }
  }, [postcode, postcodeValid]);

  useEffect(() => {
    if (isMobile) {
      window.addEventListener("scroll", throttle(openFormIfAtBottom, 200));
    }
    return () =>
      window.removeEventListener("scroll", throttle(openFormIfAtBottom, 200));
  }, []);

  return (
    <>
      {(loading || (useVariant === null && postcode)) && (
        <LoadingPlaceholder height={{ default: "200px", tablet: "580px" }} />
      )}
      {!loading && (useVariant !== null || !postcode) && (
        <PostCodeSearchMessages
          postcode={postcode}
          postcodeValid={postcodeValid}
        />
      )}
    </>
      // {!loading && useVariant !== null && postcode && carersTotal >= carersMin && (
      //   <>
      //     {!taxonomies && (
      //       <LoadingPlaceholder
      //         height={{ default: "200px", tablet: "580px" }}
      //       />
      //     )}
      //     {taxonomies && (
      //       <>
      //         <OnboardingCTA
      //           isFormOpen={isFormOpen}
      //           isMobile={isMobile}
      //           toggleFormOpenState={toggleForm}
      //         />
      //         {isFormOpen && (
      //           <OnboardingFormContainer
      //             isMobile={isMobile}
      //             isFormOpen={isFormOpen}
      //             postcode={postcode}
      //             toggleFormOpenState={toggleForm}
      //             taxonomies={taxonomies}
      //             useVariant={useVariant}
      //           />
      //         )}
      //       </>
      //     )}
      //   </>
      // )}
  );
};

export default PostcodeSearchPage;
